import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { checkTranslation, imageAddress, translate } from '../../utils/useful';

class RecentlyWidget extends Component {

    state = {
        tabs: 'applets',
    }

    componentDidMount() {
        // this.init()
        // console.log('this.props.inbox', this.props.inbox)
        this.main.addEventListener('wheel', this.onWheel, true)
    }


    componentWillUnmount() {
        this.main.removeEventListener('wheel', this.onWheel)
    }

    onWheel = (e) => {
        e.stopPropagation()
    }


    setHubs = () => {
        this.setState({ tabs: "hubs" })
    }

    setApplet = () => {
        this.setState({ tabs: "applets" })
    }

    openApplet = (username, urlcode) => {
        let path = [username, urlcode]
        this.props.addNewWindow('applet', { path: path })
    }

    render() {
        return (
            <div className="w-100 h-100  d-flex flex-column sc-2" style={{ justifyContent: 'space-between', }}>
                <div className="flexcb pt-2 pb-2 px-3 flex-wrap" >
                    <div className="">
                        <p className="text-bold text-normal" style={{ whiteSpace: 'nowrap', }}>{translate("Recently used")}</p>
                        {/* <p className="text-semibold text-smaller" style={{}}>{translate("This is a new test text")}</p> */}

                    </div>
                    {/* <div className="flexc " style={{}}>
                        <button className="mrd-2 br-20" style={{ background: this.state.tabs == 'applets' ? 'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))' : '#eee' }} onClick={() => this.setApplet()}>
                            <p className={" px-4 py-2 flexcc weight-600 text-smaller " + (this.state.tabs == 'applets' ? 'white' : 'main-c7')}>{translate('Applets')}</p>
                        </button>
                        <button className="mld-2 br-20" style={{ background: this.state.tabs == 'hubs' ? 'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))' : '#eee' }} onClick={() => this.setHubs()}>
                            <p className={" px-4 py-2 flexcc weight-600 text-smaller " + (this.state.tabs == 'hubs' ? 'white' : 'main-c7')}>{translate('Hubs')}</p>
                        </button>
                    </div> */}

                    <div className="flexc " style={{}}>
                        <button className=" " style={{ color: this.state.tabs == 'applets' ? 'rgb(88, 86, 214)' : '#777', borderBottom: this.state.tabs == 'applets' ? '2px solid rgb(88, 86, 214)' : '2px solid transparent' }} onClick={() => this.setApplet()}>
                            <p className={" px-2 py-2 flexcc weight-600 text-small "}>{translate('Applets')}</p>
                        </button>
                        <button className="mld-2 " style={{ color: this.state.tabs == 'hubs' ? 'rgb(88, 86, 214)' : '#777', borderBottom: this.state.tabs == 'hubs' ? '2px solid rgb(88, 86, 214)' : '2px solid transparent' }} onClick={() => this.setHubs()}>
                            <p className={" px-2 py-2 flexcc weight-600 text-small "}>{translate('Hubs')}</p>
                        </button>
                    </div>
                </div>
                {this.props.user.loggedin && (
                    <div className="flex-1  pt-1 sc-gray2 h-100" ref={el => this.main = el} style={{ maxHeight: '400px', overflow: 'auto', alignSelf: 'stretch', flex: 1, width: '100%' }}>
                        {this.state.tabs == 'hubs' && (
                            <div className="d-flex flex-column sc-gray2 flex-1 w-100 px-3" ref={el => this.portalsContainer = el} style={{ overflowX: 'auto', justifyContent: 'center' }}>
                                {this.props.relations.relations.map((item, index) => {
                                    return (
                                        <div key={index} className="pb-2 pt-2" style={{ transition: 'all 0.5s', cursor: 'pointer', borderBottom: '1px solid #f6f6f6' }} onClick={() => { this.props.addNewWindow("hub", { path: [item.targetHub?.username], type: 'hub' }, "center") }} >
                                            <div className="flexc" style={{ position: 'relative' }}>
                                                <img src={imageAddress(item?.targetHub?.image, "profile", 'thumb')} style={{ width: '40px', height: '40px', borderRadius: 40, objectFit: 'cover', }} />
                                                <div className=' pld-3'>
                                                    <p className="mb-0 font-size-14 mt-2 text-semibold" style={{ color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{checkTranslation(item?.targetHub?.name)}</p>
                                                    <p className="mb-0 font-size-11 text-semibold" style={{ color: '#999', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>@{item?.targetHub?.username}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                        {this.state.tabs == 'applets' && (
                            <div className="d-flex flex-column sc-gray2 flex-1 w-100 px-3" ref={el => this.portalsContainer = el} style={{ overflowX: 'auto', justifyContent: 'center' }}>
                                {this.props.connection?.connections?.map((item, index) => {
                                    return (
                                        <div key={index} className="pb-2 pt-2 flexcb" style={{ transition: 'all 0.5s', cursor: 'pointer', borderBottom: '1px solid #f6f6f6' }} onClick={() => this.openApplet(item.appletHub.username, item.applet.urlcode)} >
                                            <div className="flexc" style={{ position: 'relative' }}>
                                                {item.applet?.image ? (
                                                    <div className="position-relative">
                                                        <img src={imageAddress(item.applet.image, 'applet')} style={{ width: '40px', height: '40px', borderRadius: 40, objectFit: 'cover', objectFit: "cover" }} />
                                                        <div className="position-absolute br-50 flexcc" style={this.props.language == 'fa' ? { bottom: 0, left: 65, width: 25, height: 25, border: '1px solid #eee' } : { backgroundColor: '#fff', bottom: 0, right: -8, width: 25, height: 25, border: '1px solid #eee' }}>
                                                            <img className="" src={('/assets/icons/applets/' + ((item?.features && item?.features[0]) ? String(item?.features[0]).toLowerCase() : String(item.applet?.type).toLowerCase()) + ".png")} style={{ width: 22, height: 22, borderRadius: '50%', border: '0px solid #eee' }} />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="position-relative">
                                                        <div className="flexcc" style={{ backgroundColor: '#00000010', borderRadius: 30, width: '40px', height: '40px', }}>
                                                            <img src={('/assets/icons/applets/' + ((item?.features && item?.features[0]) ? String(item?.features[0]).toLowerCase() : String(item.applet?.type).toLowerCase()) + ".png")} style={{ width: '36px', height: '36px', objectFit: 'cover', objectFit: "cover" }} />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className='d-flex flex-column pld-4'>
                                                    <p className="mb-0 font-size-14 text-semibold" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTranslation(item.applet?.name)}</p>
                                                    <p className="mb-0 font-size-12 " style={{ color: '#777', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{item.appletHub?.fullname}</p>
                                                </div>

                                            </div>

                                            {this.props.inbox.object[item.applet?._id]?.count > 0 && (
                                                <div className="br-30 flexcc px-1" style={{ backgroundColor: '#ee5050', minWidth: '20px', height: '20px', }}>
                                                    <p className="white font-size-12 text-semibold">{checkTranslation(this.props.inbox.object[item.applet?._id]?.count)}</p>
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                )}

            </div>
        );
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connection: state.connection, inbox: state.inbox, relations: state.relations })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(RecentlyWidget);